// extracted by mini-css-extract-plugin
module.exports = {"onTrack":"#3AB686","behind":"#d6a053","atRisk":"#AF4E30","prime":"#606060"};